export default __webpack_public_path__ + "static/media/comet-app-icon.99ae39b9.png";